<nav class="fs-20px am-nav-header">

  <div class="am-main">
    <div class="header bg-white am-main-size">
      <div class="px-2 am-header-class">
        <div class="d-flex">
          <div class="nav-counter"> {{indexSegment}} {{ 'seatReview.of' | translate}} {{reservation.segments.length}}
          </div>
          <div class="nav-trip"> {{selectedTrip.departureAirport}} -> {{selectedTrip.arrivalAirport}}</div>
          <div class="px-2 header-picker border-am-left">
            <a class="button-picker" (click)="validateShowDiv('nav')" data-bs-toggle="collapse" role="button" href="#id"
              aria-expanded="false" aria-controls="id">
              <i class="fas fa-caret-down fa-2x ml-2 am-icon"
                [ngClass]="{'fa-caret-up': navTab === true, 'fa-caret-down': navTab == false}"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="p-4 class-properties collapse am-collade am-background-color" id="id" aria-labelledby="id"
      data-parent="#rateBox">
      <div class="am-content-options" *ngFor="let reservatio of reservation.segments; let i = index">
        <div class="d-flex am-nav-div">
          <div class="nav-counter"> {{i+1}} {{ 'seatReview.of' | translate}} {{reservation.segments.length}} </div>
          <div class="nav-trip"> {{reservatio.departureAirport}} -> {{reservatio.arrivalAirport}}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="nav-notice am-main">
    <div class="am-header-class">{{'seatReview.subtitleSeat' | translate}} </div>

  </div>
  <div class="nav-subtotal am-main">
    <span class="my-1 text-am-blue-light fs-16px am-border">{{'seatReview.subtotal' | translate}}</span>
    <span class="am-border">
      <b class="">{{totalSeatsPassengers | amCurrency}}</b> <span class="fs-16px"> </span>
    </span>
  </div>
  <div class="nav-exit">
    <button (click)="onExit()">
      {{'seatReview.save&exist' | translate | titlecase}}
    </button>
  </div>
</nav>

<div class="am-seat-view">
  <app-am-scroll [height]="834">
    <div [ngClass]="{
                'Plane-B737-180': airplane === 'P180',
                'Plane-B737-166': airplane === 'P166',
                'Plane-B737-9': airplane === 'P7379',
                'Plane-EMB190': airplane === 'PE190',
                'Plane-B787-8': airplane === 'P7878',
                'Plane-B787-9': airplane === 'P7879'
                }">
      <div class="plane" *ngIf="seatMapSections">
        <app-am-map-plane [airplane]='airplane' [seatDiv]='row' [index]="i"
          *ngFor="let row of seatMapSections ; index as i"></app-am-map-plane>
      </div>
    </div>
  </app-am-scroll>
  <div class="am-class-boxes" id="rateBox">
    <div *ngIf="seatMap" class="text-am-dark-gray fs-18px am-name-airplane">
      {{ seatMap.name }}
    </div>

   
  </div>
</div>

<div id="Bloquear" *ngIf="showDiv==true"></div>
<footer class="fs-26px am-footer">
  <div class="footer-passengers am-footer-he  am-footer-class">
    {{'bagsSelection.table.headers.passenger' | translate}} {{nextPosition + 1}} {{ 'seatReview.of' | translate}}
    {{passengers.length}}
  </div>
  <div class="main footer-current-passengers am-footer-he ">
    <div class="header bg-white am-footer-list">
      <div class="px-2 header-class  am-footer-class-name">
        <div class="d-flex">
          <div class="am-passengers"> {{currentPassenger.displayName | titlecase}}</div>

          <div class="px-2 header-picker border-am-right am-passengers-up">
            <a class="button-picker" (click)="validateShowDiv('footer')" data-bs-toggle="collapse" role="button" href="#passengersList "
              aria-expanded="false" aria-controls="passengersList" (click)="  ('footer')">
              <i class="fas fa-caret-up fa-2x ml-2 am-icon"
                [ngClass]="{'fa-caret-up': footerTab === false, 'fa-caret-down': footerTab == true}"></i>
            </a>
          </div>
        </div>
      </div>
    </div>


    <div class="p-4 class-properties collapse am-collade am-panel-table" id="passengersList"
      aria-labelledby="paspassengersListsengers" data-parent="#rateBox">
      <app-am-scroll  [height]="270">
        <div class = "am-size-table">
          <table class="am-table">
            <thead class="am-thead">
            <tr class="am-table-row">
              <th class="fs-14px" style="background-color: unset">{{'frequent-flyer.listPassenger.header.table.colum1' |
                translate}}</th>
              <th class="am-table-column fs-14px" style="width:  20%;">{{'seatReview.SeatDescription'| translate}}</th>
              <th class="am-table-column fs-14px" style="width:  20%;"> {{'seatReview.type'| translate}}</th>
              <th class="am-table-column fs-14px" style="width:  20%;"> {{'seatReview.titlePrice'| translate}}</th>
            </tr>
            </thead>
            <tbody class="am-table-body">
            <tr class="am-table-row" *ngFor="let passanger of passengers">
              <td class="am-table-column fs-18px"><span class="text-capitalize">{{passanger.displayName | titlecase }}</span></td>

              <td class="am-table-column fs-18px opacity-50" *ngIf="getCodeSeat(passanger.seats,selectedTrip, 'code') == ''"> {{ 'seatReview.withoutSeat' | translate }} </td>
              <td class="am-table-column fs-18px opacity-50" *ngIf="getCodeSeat(passanger.seats,selectedTrip, 'code') != ''"> <b>{{ getCodeSeat(passanger.seats,selectedTrip, 'code')}}</b>  </td>
              <td class="am-table-column fs-18px opacity-50" *ngIf="getCodeSeat(passanger.seats,selectedTrip, 'type') == '' "> {{ 'seatReview.withoutSeat' | translate }} </td>
              <td class="am-table-column fs-18px opacity-50" *ngIf="getCodeSeat(passanger.seats,selectedTrip, 'type') != ''">{{getCodeSeat(passanger.seats,selectedTrip, 'type')| translate}}</td>
              <td class="am-table-column fs-18px opacity-50">
                <div class="d-flex">
                  <div class="fs-18px" *ngIf="getCodeSeat(passanger.seats,selectedTrip, 'code') == ''"> {{ 'seatReview.withoutSeat' | translate }} </div>
                  <div class="fs-18px" *ngIf="getCostSeat(passanger.seats,selectedTrip) > 0"> {{ getCostSeat(passanger.seats,selectedTrip) | amCurrency }} </div>
                  <div class="am-icon-circle" *ngIf="getCostSeat(passanger.seats,selectedTrip) > 0">
                    <i class="fas fa-check-circle  fa-2x ml-2 am-icon-circle"></i>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </app-am-scroll>
    </div>

  </div>

  <div class="footer-button ">
    <app-button [text]="'seatReview.NEXT_PASSENGER'" [width]="'325px'" height="85px"
      (amClick)="nextPassenger()"></app-button>
  </div>
</footer>
